import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllGroupsNotPaginatedUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllGroupsNotPaginated
  implements GetAllGroupsNotPaginatedUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllGroupsNotPaginatedUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetAllGroupsNotPaginatedUseCaseInterface.Params,
  ): Promise<GetAllGroupsNotPaginatedUseCaseInterface.Result> {
    const requestUrl = `${this.url}/0/0`;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(requestUrl, params),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
